export default __webpack_public_path__ + "static/media/trailer.7a3e429c.mp4";